export class Module {
    id: number;
    name: string;
    description: string;
    coverUrl: string;
    videoUrl: string;
    videoDuration: number;
    modulePoints: number;
    isWatched: boolean;
    exerciseCompleted: boolean;
    quizCompleted: boolean;
    quiz: Array<[]>;
    summary: Array<[]>;
    breathingExerciseUrl: string;
}
